import React from 'react';
import { checkPermission } from '../../Utils/permissionHelper';

const StatusButton = ({
    status,
    onStatusChange,
    permission = null,
    editPermission = null,
    disabled = false,
    activeText = "Active",
    inactiveText = "Inactive",
    activeClass = "active-btn btn-success",
    inactiveClass = "inactive-btn btn-danger"
}) => {
    const handleClick = () => {
        if (onStatusChange) {
            onStatusChange(status);
        }
    };

    // Check both specific permission and edit permission
    const hasPermission = permission ? checkPermission(permission) : true;
    const hasEditPermission = editPermission ? checkPermission(editPermission) : true;
    const isDisabled = disabled || !hasPermission || !hasEditPermission;

    const buttonStyle = isDisabled ? { opacity: 0.6, cursor: 'not-allowed' } : {};

    return (
        <button
            onClick={handleClick}
            className={status ? activeClass : inactiveClass}
            disabled={isDisabled}
            style={buttonStyle}
        >
            {status ? activeText : inactiveText}
        </button>
    );
};

export default StatusButton;
